// vorvani-quantity-breaks-cart-fix.js
// 1) Envía al carrito una variante por slot (#1, #2...) del bundle seleccionado.
// 2) Recalcula el precio mostrado del bundle según las variantes elegidas.
// v2: el "Ahorras [amount_saved]" ahora muestra el ahorro real (antes mostraba el total del bundle).
(function () {
  'use strict';

  function getVariants(qbEl) {
    var script = qbEl.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent.trim()) || []; }
    catch (e) { console.error('[VORVANI bundle fix] JSON de variantes inválido:', e); return []; }
  }

  function matchVariant(variants, selectedOptions) {
    return variants.find(function (v) {
      var opts = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      if (opts.length !== selectedOptions.length) return false;
      return opts.every(function (opt, i) { return String(opt) === String(selectedOptions[i]); });
    });
  }

  function getSlotVariant(selectorItem, variants) {
    var selects = Array.from(selectorItem.querySelectorAll('select.variant-dropdown, select.select__select, select'));
    if (selects.length === 0) {
      var fid = parseInt(selectorItem.dataset.selectedId, 10);
      return variants.find(function (v) { return v.id === fid; }) || (fid ? { id: fid } : null);
    }
    var matched = matchVariant(variants, selects.map(function (s) { return s.value; }));
    if (matched) return matched;
    console.warn('[VORVANI bundle fix] Variante no encontrada para el slot');
    var id = parseInt(selectorItem.dataset.selectedId, 10);
    return id ? { id: id } : null;
  }

  function getActiveLabel() {
    var checked = document.querySelector('.quantity-breaks-container input[type="radio"]:checked');
    if (!checked) return null;
    return document.querySelector('label[for="' + checked.id + '"]');
  }

  // Agrupa variantes iguales en un solo line item (para que el descuento automático "mínimo N" se dispare)
  function buildCartItems(qbEl) {
    var label = getActiveLabel();
    if (!label) return null;
    var selectorItems = Array.from(label.querySelectorAll('.quantity-break__selector-item'));
    if (selectorItems.length === 0) return null;
    var variants = getVariants(qbEl);
    var grouped = {};
    selectorItems.forEach(function (item) {
      var v = getSlotVariant(item, variants);
      if (!v || !v.id) return;
      if (grouped[v.id]) grouped[v.id].quantity += 1;
      else grouped[v.id] = { id: v.id, quantity: 1 };
    });
    var items = Object.keys(grouped).map(function (k) { return grouped[k]; });
    return items.length > 0 ? items : null;
  }

  function fmtCents(cents) {
    var pesos = Math.round(cents / 100);
    return '$ ' + pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var PRICE_RE = /^\$\s*[\d,]+(\.\d{2})?$/;

  function updateLivePrice(qbEl) {
    var label = getActiveLabel();
    if (!label) return;
    var selectorItems = Array.from(label.querySelectorAll('.quantity-break__selector-item'));
    if (selectorItems.length === 0) return;

    var variants = getVariants(qbEl);
    var percentageLeft = parseFloat(label.dataset.percentageLeft);
    var fixedAmountOff = parseInt(label.dataset.fixedAmountOff, 10);
    if (isNaN(percentageLeft) || isNaN(fixedAmountOff)) return;

    var totalCents = 0, compareCents = 0, allFound = true;
    selectorItems.forEach(function (item) {
      var v = getSlotVariant(item, variants);
      if (v && v.price != null) {
        totalCents += v.price;
        compareCents += v.price;
      } else { allFound = false; }
    });
    if (!allFound) return;

    var bundleCents = Math.max(0, Math.round(totalCents * percentageLeft) - fixedAmountOff);
    var savedCents = Math.max(0, compareCents - bundleCents);
    var eachCents = Math.round(bundleCents / (selectorItems.length || 1));

    var priceSpan = label.querySelector('.quantity-break__price span');
    if (priceSpan && PRICE_RE.test(priceSpan.textContent.trim())) priceSpan.textContent = fmtCents(bundleCents);

    // Textos con precio dentro de label / beneficio / caption / badge: decide qué valor va según el contexto
    label.querySelectorAll('.quantity-break__label-text span, .quantity-break__benefit span, .quantity-break__caption span, .quantity-break__badge span').forEach(function (span) {
      if (!PRICE_RE.test(span.textContent.trim())) return;
      var ctx = span.parentElement ? span.parentElement.textContent : '';
      if (/ahorr|save|descuento/i.test(ctx)) span.textContent = fmtCents(savedCents);
      else if (/c\/u|cada|each|por set|por par/i.test(ctx)) span.textContent = fmtCents(eachCents);
      else span.textContent = fmtCents(bundleCents);
    });
  }

  function installPriceListeners(qbEl) {
    qbEl.addEventListener('change', function (evt) {
      if (evt.target && evt.target.matches('select.variant-dropdown, select.quantity-break__variant-select, select.select__select')) updateLivePrice(qbEl);
    });
    var container = qbEl.querySelector('.quantity-breaks-container');
    if (container) {
      container.addEventListener('change', function (evt) {
        if (evt.target && evt.target.type === 'radio' && evt.target.name === 'quantity') setTimeout(function () { updateLivePrice(qbEl); }, 30);
      });
    }
    updateLivePrice(qbEl);
  }

  function handleSubmit(evt) {
    var qbEl = document.querySelector('quantity-breaks');
    if (!qbEl) return;
    var activeLabel = getActiveLabel();
    if (!activeLabel || !activeLabel.querySelector('.quantity-break__selector-item')) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var form = evt.target;
    var items = buildCartItems(qbEl);
    if (!items || items.length === 0) {
      console.warn('[VORVANI bundle fix] No se pudieron leer las variantes por slot. Usando submit normal.');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; });
      return;
    }

    var productFormEl = form.closest('product-form');
    var submitBtn = productFormEl ? productFormEl.querySelector('[type="submit"]') : form.querySelector('[type="submit"]');
    var spinner = productFormEl ? productFormEl.querySelector('.loading-overlay__spinner') : null;
    if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = 'cart-drawer,cart-icon-bubble';
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try { sections = cart.getSectionsToRender().map(function (s) { return s.section || s.id; }).join(','); } catch (e) {}
    }
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Error al agregar al carrito');
        if (!data.id && data.items && data.items[0]) data.id = data.items[0].id || data.items[0].variant_id;
        if (cart && typeof cart.renderContents === 'function') cart.renderContents(data);
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function (err) {
        console.error('[VORVANI bundle fix] Error al agregar el bundle:', err);
        var wrap = productFormEl ? productFormEl.querySelector('.product-form__error-message-wrapper') : null;
        var msg = wrap ? wrap.querySelector('.product-form__error-message') : null;
        if (wrap) wrap.removeAttribute('hidden');
        if (msg) msg.textContent = err.message || 'No se pudo agregar el bundle al carrito.';
      })
      .finally(function () {
        if (submitBtn) { submitBtn.classList.remove('loading'); submitBtn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function installOnForm(form) { form.addEventListener('submit', handleSubmit, true); }

  function init() {
    var FORM_SEL = 'product-form form[action*="/cart/add"], form[data-type="add-to-cart-form"]';
    var forms = document.querySelectorAll(FORM_SEL);
    forms.forEach(installOnForm);
    var qbEl = document.querySelector('quantity-breaks');
    if (qbEl) installPriceListeners(qbEl);

    if (forms.length === 0 || !qbEl) {
      var observer = new MutationObserver(function () {
        var newForms = document.querySelectorAll(FORM_SEL);
        var newQb = document.querySelector('quantity-breaks');
        if (newForms.length > 0 && forms.length === 0) { newForms.forEach(installOnForm); forms = newForms; }
        if (newQb && !qbEl) { qbEl = newQb; installPriceListeners(qbEl); }
        if (forms.length > 0 && qbEl) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
